import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import CouponGreyIcon from "../../img/svg/coupon-grey.svg";
import CouponIcon from "../../img/svg/coupon.svg";
import LeftArrowIcon from "../../img/svg/Left_arrow.svg";
import "../../styles/multipleEntryPass.scss";
import { isPartnerMaoflaamit } from "../../store/partnerStore";
import { formatDate } from "../../utils/dateUtils";

const MultipleEntryPassItem = ({ pass, index, array, onClick }) => {
  const { t } = useTranslation();
  const isMaoflaamit = useSelector(isPartnerMaoflaamit);

  const handleClick = () => {
    if (onClick) {
      onClick(pass);
    }
  };

  return (
    <div>
      <div
        className={`multiple-entry-pass__item ${
          pass.IsAvailable
            ? "multiple-entry-pass__item--active"
            : "multiple-entry-pass__item--inactive"
        }`}
        onClick={handleClick}
        style={{ cursor: "pointer" }}
      >
        <div
          className={`multiple-entry-pass__icon ${
            pass.IsAvailable
              ? "multiple-entry-pass__icon--active"
              : "multiple-entry-pass__icon--inactive"
          }`}
        >
          <img
            src={pass.IsAvailable ? CouponIcon : CouponGreyIcon}
            alt="Coupon"
            style={{ width: "1rem", height: "1rem" }}
          />
        </div>
        <div className="multiple-entry-pass__content">
          <Typography className="multiple-entry-pass__title">
            {isMaoflaamit ? `כרטיסיית ${pass.PossibleNumberOfEntries} כניסות` : t("MULTIPLE_ENTRY_PASS_DETAILS")}
          </Typography>
          <Typography className="multiple-entry-pass__date">
            {pass.IsAvailable
              ? t("EXPIRES_ON", { date: formatDate(pass.EndDate) })
              : t("USED_ENTRIES", { date: formatDate(pass.EndDate) })}
          </Typography>
        </div>
        <img
          src={LeftArrowIcon}
          alt="Arrow"
          className="multiple-entry-pass__arrow"
        />
      </div>
      {index < array.length - 1 && (
        <div className="divider-wrapper">
          <Divider />
        </div>
      )}
    </div>
  );
};

export default MultipleEntryPassItem;
